import React from "react";

export default class PojazdFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: ''
        }

        this.filter = this.filter.bind(this);
        this.isFiltered = this.isFiltered.bind(this);
    }

    filter(event) {
        this.setState({value: event.target.value})
        if (this.refs.pojazdInput.value === '') {
            this.props.filterHandler();
        } else {
            this.props.filterHandler({callback: this.isFiltered});
        }
    }

    isFiltered(targetValue) {
        if ((targetValue.marka + ' ' + targetValue.model + ' ' + targetValue.nrRej).toLowerCase().indexOf(this.refs.pojazdInput.value.toLowerCase()) >= 0 ) {
            return targetValue
        }
    }

    render() {
        return (
            <div>
                <input ref='pojazdInput' type='text' className='form-control' placeholder='Szukaj'
                       value={this.state.value} onChange={this.filter}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/zarzadzanie/filters/PojazdFilter.js